import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { NavLinks } from "../../components/NavLinks/NavLinks";
import { useUser } from "../../contexts/userContext";
import { AccountHeader } from "./AccountHeader";
import { Overview } from "./components/Overview";
import { Settings } from "./components/settings/Settings";

const links = [
  { to: "/account/overview", title: "Overview" },
  { to: "/account/settings", title: "Settings" },
];

const AccountPage: React.FC = () => {
  const { user } = useUser();
  return (
    <>
      <AccountHeader userData={user} />
      <NavLinks linkData={links} />
      <div className="mt-n2">
        <Routes>
          <Route path="overview" element={<Overview userData={user} />} />
          <Route path="settings" element={<Settings />} />
          <Route index element={<Navigate to="/account/overview" />} />
        </Routes>
      </div>
    </>
  );
};

export default AccountPage;
